import { AerodromoService } from 'src/app/services/geral/aerodromo.service';
import { Aerodromo } from 'src/app/model/geral/aerodromo';
import { Component, Injector, OnInit } from '@angular/core';
import { ListaSimplesGenerica } from '../../generic/listagenerica/listasimplesgenerica';

@Component({
  selector: 'app-lista-aerodromo',
  templateUrl: '../../generic/listagenerica/listasimples.component.html',
  styleUrls: [ '../../generic/listagenerica/listasimples.component.css']
})

export class ListaAerodromoComponent extends ListaSimplesGenerica<Aerodromo> implements OnInit {

  override obj = new Aerodromo();

  constructor(
    injectorObj: Injector,
    api: AerodromoService) 
  {
    super(injectorObj, api);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraList(res: any) {
  }

  override getColorCell(valor: any) {   
  }

}
